export default "__VITE_ASSET__43981142__"